import { useInfiniteQuery, useMutation } from '@tanstack/react-query';

import { getNotificationFeed, registerDeviceFCMToken } from '../functions/notifications';
import { NotificationFeedParam } from '../models/notificationsModels';

export const useRegisterFCMToken = () =>
  useMutation({
    mutationKey: ['register-device-FCM-token'],
    mutationFn: registerDeviceFCMToken
  });

export const useGetNotificationFeed = (params: NotificationFeedParam) =>
  useInfiniteQuery({
    queryKey: ['get-notification-feed', params.n, params.limit, params.markAsRead],
    queryFn: getNotificationFeed,
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => {
      if (lastPage.last) {
        return lastPage.last;
      } else {
        return null;
      }
    }
  });
